import declare from "dojo/_base/declare";
import NumberRen from "csi/heading/Number";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import html from "csi/html";

const AdHocNumberRenderer = declare(NumberRen, {
	/**
	 * @override
	 * Return empty string if not an ad-hoc request
	*/
	toValue(ctx: Context, h: Heading): string {
		return ctx.getNode().ClientStartRendering ? this.inherited<string>(arguments) : "";
	},

	/**
	 * @override
	 * Hash out cell if not an ad-hoc request
	 */
	_getRenderCSS(ctx: Context, h: Heading, refNode: HTMLElement): string {
		return ctx.getNode().ClientStartRendering ? this.inherited<string>(arguments) : html.CSS_NOT_APPLICABLE;
	},
});

export = AdHocNumberRenderer;